import React from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { logout } from "../features/authSlice";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();

  // Directly check for the token from the cookie
  const token = Cookies.get("accessToken");

  // If no token is found, dispatch logout and redirect to login
  if (!token) {
    dispatch(logout());
    return <Navigate to="/login" />;
  }

  // If token is found, allow access to the children components (protected route)
  return children;
};

export default ProtectedRoute;
